export default __webpack_public_path__ + "static/media/business_show_7.40408544.png";